module.exports = __webpack_public_path__ + "media/application/images/icons/file-icon-8cc9ba18290812f28c66462510e149fd.svg";